"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSidebarBottomTriangle = function SvgSidebarBottomTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    preserveAspectRatio: "none",
    viewBox: "0 0 218 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.33-.153v1.154a5.65 5.65 0 0 0 5.138 5.626l103.426 9.504 103.63-9.504A5.65 5.65 0 0 0 217.664 1V-.153H.33Z",
    stroke: "#C2C5CC",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.682-2h216.63v3H.682z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSidebarBottomTriangle);
var _default = exports["default"] = Memo;